import React from "react";
import { useSelector } from "react-redux";
import { Card, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const Profile = () => {
    // Get the current user from the Redux store
    const user = useSelector((state) => state.user.data);
    const rules = useSelector((state) => state.user.roles);


    if (!user) {
        return (
            <div className="text-center mt-5">
                <h3>Nu sunteți autentificat!</h3>
                <NavLink to="/login" className="btn btn-primary mt-3">
                    Autentificare
                </NavLink>
            </div>
        );
    }

    return (
        <Card className="profile-card mx-auto mt-5" style={{ maxWidth: "500px" }}>
            <Card.Header className="text-center">
                <h4>Profilul Utilizatorului</h4>
            </Card.Header>
            <Card.Body>
                <p><strong>Email:</strong> {user.userName || "N/A"}</p>
                <p><strong>Tenant:</strong> {user.tenant || "N/A"}</p>
                {rules && rules.length > 0 && (
                    <div>
                        <p><strong>Roluri:</strong></p>
                        <ul>
                            {rules.map((role, index) => (
                                <li key={index}>{role}</li>
                            ))}
                        </ul>
                    </div>
                )}
                <div className="text-center mt-4">
                    <NavLink to="/schimbare-parola">
                        <Button variant="primary">Schimbare Parolă</Button>
                    </NavLink>
                </div>
            </Card.Body>
        </Card>
    );
};

export default Profile;